import React, { useEffect, useState } from "react";
import Header from "../Core/Header";
import Footer from "../Core/Footer";
import Cookies from "js-cookie";
import {
  applyCoupon,
  bookBus,
  getCoupon,
  getProfile,
} from "../../service/operations/api_methods";
import { useSelector } from "react-redux";
import { useMediaQuery } from "usehooks-ts";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader, Loader2 } from "lucide-react";
import { baseURL } from "../../service/api_endpoints";
import BusDetails from "./BusDetails";

const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const Payment = () => {
  const token = Cookies.get("roam-token");

  const mobile = useMediaQuery("(max-width: 767px)");
  const [isActive, setIsActive] = useState(false);
  const [waitingList, setWaitingList] = useState(false);
  const navigate = useNavigate();

  const getFromLocal = (key) => {
    const data = localStorage.getItem(key);
    if(!data){
      navigate("/")
    }
    return data ? JSON.parse(data) : "";
  };

  const [bookingDetals, setBookingDetails] = useState(() => {
    const data = getFromLocal("roam-booking");

    // If "down" exists → return only down
    if (data.down) {
      return data.up;
    }
    // Otherwise return full object
    return data;
  });

  const [realBookingDetails, setRealBookingDetaiuls] = useState(
    getFromLocal("roam-booking"),
  );

  const plan = useSelector((state) => state.booking.plan);
  const [availableCoupon, setAvailableCoupon] = useState([]);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [totalSeats, setTotalSeats] = useState(0);

;    const [accountName, setAccountName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");

  useEffect(() => {
    console.log(bookingDetals);

    const total = bookingDetals?.seatNumbers?.length || 0;
    setTotalSeats(total);
  }, [bookingDetals]);

  useEffect(()=>{
  const handleGetProfile = async () => {
      try {
        const response = await getProfile(token);
        console.log("profile", response);
        if (response.status === 200) {
          setAccountName(response.data.user.name);
          setEmail(response.data.user.email);
          setPhone(response.data.user.phone);
         
        }
      } catch (error) {
        console.log(error);
      }
    };

    handleGetProfile()
  },[])

  const [name, setName] = useState(Array(totalSeats).fill(""));
  const [phNum, setPhNum] = useState(Array(totalSeats).fill(""));
  const [age, setAge] = useState(Array(totalSeats).fill(""));
  const [gen, setGen] = useState(Array(totalSeats).fill(""));

  const [payModal, setPayModal] = useState(false);
  const [load, setLoad] = useState(false);

  const [bookingId, setBookingId] = useState("");
  const [downBookingId, setDownBookingId] = useState("");
  const [platformFeePercentage, setPlatformFeePercentage] = useState(() => {
    return bookingDetals?.selectedBus?.routes[0]?.fareBreakup
      ?.platformFeePercentage;
  });


    const [platformFeeFixed, setPlatformFeeFixed] = useState(() => {
    return bookingDetals?.selectedBus?.routes[0]?.fareBreakup
      ?.platformFeeFixedAmount;
  });

  const totalCalculation = (total) => {
    return Number(
      total +
      (platformFeePercentage!==0? ( Number(total * platformFeePercentage||0) / 100):platformFeeFixed )+
        Number(total * bookingDetals?.selectedBus?.fareDetails?.sgstPercentage||0) / 100 +
        Number(total * bookingDetals.selectedBus.fareDetails.cgstPercentage||0) / 100,
    );
  };

  const totalCuoponCalculation = (total) => {
    return totalCalculation(
      (total * Number(100-selectedCoupon.discountPercentage)) / 100,
    );
  };

  const formattedDate = (date) => {
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleNameChange = (index, newValue) => {
    setName((prev) => {
      const updated = [...prev];
      updated[index] = newValue;
      return updated;
    });
  };

  const handlePhChange = (index, newValue) => {
    if (newValue.length > 10) return;
    setPhNum((prev) => {
      const updated = [...prev];
      updated[index] = newValue;
      return updated;
    });
  };

  const handleGenChange = (index, newValue) => {
    setGen((prev) => {
      const updated = [...prev];
      updated[index] = newValue;
      return updated;
    });
  };
  const handleAgeChange = (index, newValue) => {
    setAge((prev) => {
      const updated = [...prev];
      updated[index] = newValue;
      return updated;
    });
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = ""; // 🔥 required for Chrome
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handlePayment = async (bookingId) => {
    // 1️⃣ Load Razorpay SDK
    const res = await loadRazorpayScript();
    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }
    const bodyData = realBookingDetails.up
      ? {
          // round trip
          bookingId: bookingId,
          downBookingId: downBookingId,
          RoundTrip: "roundTrip",
        }
      : {
          bookingId: bookingId,
        };

    try {
      console.log("bodyData", bodyData);

      // 2️⃣ Call backend to create order
      const { data } = await axios.post(
        `${baseURL}/api/payments/create-order`,
        bodyData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      console.log("bookig data  for payment", data);

      setPayModal(false);

      // 3️⃣ Configure Razorpay payment options
      const options = {
        key: data.key, // Replace with your test key
        amount: data.order.amount,
        currency: data.order.currency,
        name: "Siance Software",
        description: "Test Transaction",
        order_id: data.order.id,
        handler: async function (response) {
          // Payment successful
          const { razorpay_payment_id, razorpay_order_id, razorpay_signature } =
            response;
          try {
            // 4️⃣ Verify payment with backend
            const verifyRes = await axios.post(
              `${baseURL}/api/payments/verify`,
              {
                razorpay_order_id,
                razorpay_payment_id,
                razorpay_signature,
                bookingId,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              },
            );

            if (verifyRes.data.success) {
              toast.success("payment verified successfully");
              localStorage.removeItem("roam-booking");
               navigate(`/ticket/${bookingId}`);
            } else {
              // alert("❌ Payment verification failed!");
              // navigate("/myprofile");
            }
          } catch (err) {
            console.error("Verification error:", err);
            // alert("Error verifying payment. Please contact support.");
          }

          // Optional: verify payment with backend here
        },
        prefill: {
          name: accountName,
          email: email,
          contact: phone,
        },
        theme: {
          color: "#3399cc",
        },
      };

      // 4️⃣ Open Razorpay checkout modal
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (err) {
      console.error(err);
      // alert("Payment failed. Check console for details.");
    }
  };

  const handlePaymentWaiting = async (bookingId) => {
    // 1️⃣ Load Razorpay SDK
    const res = await loadRazorpayScript();
    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    try {
      // 2️⃣ Call backend to create order
      const { data } = await axios.post(
        `${baseURL}/api/payments/create-order`,
        {
          waitingListId: bookingId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      console.log(data);

      setPayModal(false);

      // 3️⃣ Configure Razorpay payment options
      const options = {
        key: data.key, // Replace with your test key
        amount: data.order.amount,
        currency: data.order.currency,
        name: "Siance Software",
        description: " Transaction",
        order_id: data.order.id,
        handler: async function (response) {
          // Payment successful
          const { razorpay_payment_id, razorpay_order_id, razorpay_signature } =
            response;
          try {
            // 4️⃣ Verify payment with backend
            const verifyRes = await axios.post(
              `${baseURL}/api/payments/verify`,
              {
                razorpay_order_id,
                razorpay_payment_id,
                razorpay_signature,
                waitingListId: bookingId,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              },
            );

            if (verifyRes.data.success) {
              alert(
                "Seats are not available ,this booking is moved to waiting list",
              );
              toast.success("payment verified successfully");
              localStorage.removeItem("roam-booking");
              navigate(`/`);
            } else {
              // alert("❌ Payment verification failed!");
              navigate("/myprofile");
            }
          } catch (err) {
            console.error("Verification error:", err);
            // alert("Error verifying payment. Please contact support.");
          }

          // Optional: verify payment with backend here
        },
        prefill: {
          name: accountName,
          email: email,
          contact: phone,
        },
        theme: {
          color: "#3399cc",
        },
      };

      // 4️⃣ Open Razorpay checkout modal
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (err) {
      console.error(err);
      // alert("Payment failed. Check console for details.");
    }
  };

  const validatePassengers = () => {
    for (let i = 0; i < totalSeats; i++) {
      if (!name[i]?.trim()) {
        toast.error(`Passenger ${i + 1}: Name is required`);
        return false;
      }

      if (!phNum[i]?.trim()) {
        toast.error(`Passenger ${i + 1}: Phone number is required`);
        return false;
      }

      if (!/^\d{10}$/.test(phNum[i])) {
        toast.error(`Passenger ${i + 1}: Phone number must be 10 digits`);
        return false;
      }

      if (!age[i]) {
        toast.error(`Passenger ${i + 1}: Age is required`);
        return false;
      }

      if (!gen[i]?.trim()) {
        toast.error(`Passenger ${i + 1}: Gender is required`);
        return false;
      }
    }

    return true;
  };

  const handleBusBook = async () => {
    if (!validatePassengers()) return;

    // let numberFault=JSON.parse(bookingDetals.seatNumbers).find((_,ind)=> !/^\d{10}$/.test(String( phNum[ind])))
    // if(numberFault){
    //   toast.error('Phone numbers should be in 10 digits')
    //   return
    // }

    setLoad(true);

    let grandTotal = selectedCoupon
      ? realBookingDetails.up
        ? totalCuoponCalculation(
            Number(realBookingDetails.up.fare + realBookingDetails.down.fare) *
              totalSeats,
          )
        : totalCuoponCalculation(Number(bookingDetals.fare) * totalSeats)
      : realBookingDetails.up
        ? totalCalculation(
            Number(realBookingDetails.up.fare + realBookingDetails.down.fare) *
              totalSeats,
          )
        : totalCalculation(Number(bookingDetals.fare) * totalSeats);

    let data = {
      // for  instant booking
      objectiveData: {
        busId: bookingDetals?.selectedBus.id,
        tripType: bookingDetals.trip,
        baseAmount: grandTotal,
        discountAmount: 0,
        totalAmount: grandTotal,
        couponCode: null,
        contactDetails: {
          email: email,
          phone: phone,
        },
        passengers: bookingDetals?.seatNumbers.map((i, ind) => ({
          name: name[ind],
          age: age[ind],
          gender: gen[ind],
          isPrimary: true,
        })),
        legs: [
          {
            direction: "UP",
            journeyDate: bookingDetals?.date,
            boardingPointId: bookingDetals?.boardingPoint,
            boardingPointName: bookingDetals?.boardingPointName,
            droppingPointId: bookingDetals?.droppingPoint,
            droppingPointName: bookingDetals?.droppingPointName,
            isInstantBooking:
              bookingDetals?.booking === "instant" ? true : false,
            seatCount: bookingDetals?.seatNumbers.length,
            seats: [],

            farePerSeat: grandTotal / bookingDetals?.seatNumbers?.length,
            totalLegFare: grandTotal,
            routeId: bookingDetals?.routeId,
            timeSlotSequence: bookingDetals?.timeSlotSequence,
            arrivalTime: BusDetails?.arrivalTime,
            departureTime: BusDetails?.departureTime,
          },
        ],
      },
      token,
    };

    let data2 = {
      //for one way trip
      objectiveData: {
        busId: bookingDetals.selectedBus.id,
        tripType: "oneWay",
        baseAmount: grandTotal,
        discountAmount: 0,
        totalAmount: grandTotal,
        couponCode: null,
        contactDetails: {
          email: "example@gmail.com",
          phone: "7894561023",
        },
        passengers: bookingDetals.seatNumbers.map((i, ind) => ({
          name: name[ind],
          age: age[ind],
          gender: gen[ind],
          isPrimary: true,
        })),
        legs: [
          {
            direction: "UP",
            journeyDate: bookingDetals?.date,
            boardingPointId: bookingDetals?.boardingPoint,
            boardingPointName: bookingDetals?.boardingPointName,
            droppingPointId: bookingDetals?.droppingPoint,
            droppingPointName: bookingDetals?.droppingPointName,
            // isInstantBooking: bookingDetals.booking==="instant"?true:false,
            seatCount: bookingDetals?.seatNumbers.length,
            seats: [...bookingDetals.seatNumbers],
            farePerSeat: grandTotal / bookingDetals?.seatNumbers.length,
            totalLegFare: grandTotal,
            routeId: bookingDetals?.routeId,
            timeSlotSequence: bookingDetals?.timeSlotSequence,
            arrivalTime: BusDetails?.arrivalTime || "18:00",
            departureTime: BusDetails?.departureTime || "17:00",
          },
        ],
      },
      token,
    };



    let body = null;
    if (bookingDetals.booking === "instant") {
      body = data;
    } else if (
      bookingDetals.trip === "round" &&
      bookingDetals.booking === "regular"
    ) {
      body = {
        //for round trip
        objectiveData: {
          busId: bookingDetals.selectedBus.id,
          tripType: "roundTrip",
          baseAmount: grandTotal,
          discountAmount: 0,
          totalAmount: grandTotal,
          couponCode: null,
          contactDetails: {
            email: email,
            phone: phone,
          },
          passengers: bookingDetals.seatNumbers.map((i, ind) => ({
            name: name[ind],
            age: age[ind],
            gender: gen[ind],
            isPrimary: true,
          })),
          legs: [
            {
              direction: "UP",
              journeyDate: bookingDetals?.date,
              boardingPointId: realBookingDetails?.up?.boardingPoint,
              boardingPointName: realBookingDetails?.up?.boardingPointName,
              droppingPointId: realBookingDetails?.up?.droppingPoint,
              droppingPointName: realBookingDetails?.up?.droppingPointName,
              isInstantBooking:
                bookingDetals.booking === "instant" ? true : false,
              seatCount: bookingDetals.seatNumbers.length,
              seats: [...realBookingDetails?.up?.seatNumbers],
              farePerSeat: grandTotal / bookingDetals.seatNumbers.length,
              totalLegFare:
                bookingDetals.fare * bookingDetals.seatNumbers.length,
              routeId: bookingDetals.routeId,
              timeSlotSequence: bookingDetals.timeSlotSequence,
              arrivalTime: BusDetails.arrivalTime || "18:00",
              departureTime: BusDetails.departureTime || "17:00",
            },
            {
              direction: "DOWN",
              journeyDate: bookingDetals?.date,
              boardingPointId: realBookingDetails?.down?.boardingPoint,
              boardingPointName: realBookingDetails?.down?.boardingPointName,
              droppingPointId: realBookingDetails?.down?.droppingPoint,
              droppingPointName: realBookingDetails?.down?.droppingPointName,
              isInstantBooking:
                bookingDetals.booking === "instant" ? true : false,
              seatCount: bookingDetals.seatNumbers.length,
              seats: [...realBookingDetails?.down?.seatNumbers],
              farePerSeat: grandTotal / bookingDetals.seatNumbers.length,
              totalLegFare:
                bookingDetals.fare * bookingDetals.seatNumbers.length,
              routeId: bookingDetals.routeId,
              timeSlotSequence: bookingDetals.timeSlotSequence,
              arrivalTime: BusDetails.arrivalTime || "18:00",
              departureTime: BusDetails.departureTime || "17:00",
            },
          ],
        },
        token,
      };
    } else if (
      bookingDetals.trip === "oneWay" &&
      bookingDetals.booking === "regular"
    ) {
      body = data2;
    }
    try {
      console.log(bookingDetals);
      console.log(body);

      const response = await bookBus(body);
      console.log("bus book result", response);

      if (response.status === 201) {
        if (response.data.booking) {
          toast.success("Bus booked successfully!");
         
         
          setBookingId(response.data.booking.bookings[0].id);
          if (response.data.booking.bookings.length > 1) {
            setDownBookingId(response.data.booking.bookings[1].id);
          }
          // navigate(`/ticket/${response.data.booking.bookings[0].id}`)

         setIsActive(true);
        } else if (response.data.waitingList) {
          toast.success(response?.data?.message);
          setWaitingList(true);
  // as bus booking is complete so we dont need the  booking plan now
   //navigate(`/ticket/${response.data.booking.bookings[0].id}`)
        
        }
      }
      console.log(data);
    } catch (error) {
      console.log(error);
      
      alert(  "Some issue is found to book this seat,please wait sometime or select another seats");
      //alert("Fill all required data")
      toast.error(
        
          "Some issue is found to book this seat,please wait sometime or select another seats",
      );
    }
    finally{
        setLoad(false);
       
        // localStorage.removeItem("roam-booking");
    }
  };

  const handleGetCoupon = async () => {
    try {
      console.log(BusDetails);

      const response = await getCoupon(token);
      console.log(response);
      if (response.status === 200) {
        setAvailableCoupon(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleApplyCoupon = async (id, code) => {
    try {
      const data = {
        bookingId: id,
        couponCode: code,
        token,
      };
      const response = await applyCoupon(data);
      console.log(response);
      if (response.status === 200) {
        toast.success(
          `Coupon discount of ${response.data.booking.discountAmount} rupees`,
        );
        //  handlePayment(response.data.booking.id)
      }
    } catch (error) {
      console.log(error);
      toast.error(`Coupon not available, select another coupon and book again`);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); // scroll to top on mount
    handleGetCoupon();
  }, []);

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      <div
        style={{
          zIndex: 1000,
          backdropFilter: "blur(10px)", // blur background
          backgroundColor: "white", // transparent glass
          WebkitBackdropFilter: "blur(10px)", // for Safari
        }}
      >
        <Header />
      </div>
      <div
        style={{
          padding: mobile ? "10px" : "30px",
          width: "100%",
          backgroundColor: "rgb(226, 226, 226)",
          height: "100vh",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          filter: payModal ? "blur(5px)" : "none",
          pointerEvents: payModal ? "none" : "auto",
          transition: "all 0.5s ease",
        }}
      >
        <div style={{ height: "fit-content" }}>
          {!mobile ? (
            <div
              style={{
                display: "flex",
                alignItems: "start",
                justifyContent: "space-around",
                overflow: "auto",
                height: "fit-content",
              }}
            >
              <p
                style={{
                  padding: "6px",
                  borderRadius: "3px",
                  border: "0.3px solid grey",
                  cursor: "pointer",
                  fontWeight: "600",
                  width: "fit-content",
                  zIndex: 1000,
                  bottom: "20px",
                  left: "20px",
                }}
                onClick={() => navigate("/bus-details")}
              >
                {"< "}Back
              </p>

              <div
                style={{
                  borderRadius: "10px",
                  backgroundColor: "rgb(255, 255, 255)",
                  boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                  width: "50vw",
                  display: "flex",
                  flexDirection: "column",
                  padding: "16px",
                  maxHeight: "60vh",
                  height: "fit-content",
                }}
              >
                <p style={{ fontSize: "24px", fontWeight: "700" }}>
                  Traveller’s Details ({totalSeats} people)
                </p>
                <div
                  style={{
                    height: "fit-content",
                    overflow: "auto",
                    padding: "16px",
                  }}
                >
                  {totalSeats > 0 ? (
                    Array.from({ length: totalSeats }).map((i, index) => (
                      <div
                        style={{
                          boxShadow: "0px 0px 8px rgba(94, 36, 36, 0.2)",
                          borderRadius: "14px",
                          margin: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "20px",
                            padding: "20px",
                            width: "100%",
                          }}
                        >
                          <p>{index + 1}.</p>
                          <input
                            style={{
                              borderRadius: "4px",
                              padding: "6px",
                              fontSize: "16px",
                              border: "0.2px solid gray",
                              outline: "none",
                            }}
                            placeholder="Full name"
                            value={name[index]}
                            onChange={(e) =>
                              handleNameChange(index, e.target.value)
                            }
                          />

                          <select
                            value={gen[index]}
                            onChange={(e) =>
                              handleGenChange(index, e.target.value)
                            }
                            style={{
                              borderRadius: "4px",
                              border: "none",
                              fontSize: "16px",
                              outline: "none",
                            }}
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            gap: "20px",
                            padding: "20px",
                          }}
                        >
                          <input
                            style={{
                              borderRadius: "4px",
                              padding: "6px",
                              fontSize: "16px",
                              border: "0.2px solid gray",
                              outline: "none",
                              width: "70px",
                            }}
                            type="number"
                            placeholder="Age"
                            value={age[index]}
                            onChange={(e) =>
                              handleAgeChange(index, e.target.value)
                            }
                          />
                          <input
                            style={{
                              borderRadius: "4px",
                              padding: "6px",
                              fontSize: "16px",
                              border: "0.2px solid gray",
                              outline: "none",
                            }}
                            placeholder="Enter Phone Number"
                            type="number"
                            value={phNum[index]}
                            onChange={(e) =>
                              handlePhChange(index, e.target.value)
                            }
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No seat is selected</p>
                  )}
                </div>
              </div>

              <div
                style={{
                  borderRadius: "10px",
                  backgroundColor: "rgb(255, 255, 255)",
                  height: "fit-content",
                  boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                  width: "36vw",
                  display: "flex",
                  flexDirection: "column",
                  padding: "16px",
                  justifyContent: "left",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "20px",
                      fontWeight: "700",
                      textAlign: "center",
                    }}
                  >
                    {bookingDetals?.selectedBus.busName}
                  </p>
                  <p
                    style={{
                      fontSize: "10px",
                      fontWeight: "400",
                      color: "gray",
                      textAlign: "center",
                    }}
                  >
                    {bookingDetals?.selectedBus.busNumber}
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "gray",
                      textAlign: "center",
                    }}
                  >
                    {bookingDetals?.selectedBus.routes[0].routeName}
                  </p>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "20px",
                      marginTop: "3px",
                    }}
                  >
                    <div style={{ padding: "10px", width: "40%" }}>
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "black",
                        }}
                      >
                        {bookingDetals?.selectedBus.routes[0].origin.city}
                      </p>
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "black",
                        }}
                      >
                        {bookingDetals?.selectedBus.routes[0].origin.terminal}
                      </p>
                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          color: "gray",
                        }}
                      >
                        {
                          bookingDetals?.selectedBus.routes[0].origin
                            .departureTime
                        }
                      </p>
                    </div>

                    <div style={{ padding: "10px", width: "40%" }}>
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "black",
                        }}
                      >
                        {bookingDetals?.selectedBus.routes[0].destination.city}
                      </p>
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "black",
                        }}
                      >
                        {
                          bookingDetals?.selectedBus.routes[0].destination
                            .terminal
                        }
                      </p>
                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          color: "gray",
                        }}
                      >
                        {
                          bookingDetals?.selectedBus.routes[0].destination
                            .arrivalTime
                        }
                      </p>
                    </div>
                  </div>
                </div>
                {/* <div><p style={{fontSize:"20px",fontWeight:"700"}}>Available Coupon</p>
      <div  style={{width:"96%",overflowX:"auto",overflowY:"hidden",display:"flex",gap:"5px"}}>
      {
        availableCoupon.map((item,ind)=>(
          <div key={ind} style={{backgroundColor:selectedCoupon?.code===item.code?"rgb(187, 231, 252)":"white",height:"100%",minWidth:"60%",padding:"6px",borderRadius:"12px",marginBottom:"6px",cursor:"pointer",border:"0.3px solid grey",
            filter: !isActive ? "blur(4px)" : "none",
      pointerEvents: !isActive ? "none" : "auto",
      userSelect: !isActive ? "none" : "auto",
          }}
          onClick={()=>{ !isActive ? toast.warning("⚠️ Please complete booking first"):handleApplyCoupon(bookingId,item.code)}}>
            <p style={{fontSize:"16px",fontWeight:"600"}}>{item.code}</p>
            <p style={{display:"flex",justifyContent:"space-between",flexDirection:"column",fontWeight:"600",backgroundColor:"#757373ff",color:"rgb(250, 250, 250)",fontSize:"12px",padding:"5px",borderRadius:"4px"}}>
              <span>Offer Type : {item.type}</span>
              <span>Coupon Type :{item.couponType}</span> 
              </p>
              <p style={{fontSize:"12px",fontWeight:"600"}}>Limit :{item.limit}</p>

            <p style={{fontWeight:"500",color:"#3b4499ff",fontSize:"12px"}}>Discount :{item.discountPercentage}%</p>
            <p style={{color:"gray",fontSize:"12px"}}>{item.description}</p>
            <p style={{fontSize:"12px",fontWeight:"700"}}>Valid until :{formattedDate(item.validUntil)}</p>

          </div>
        ))
      }
      </div>
        </div>*/}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: "20px",
                    alignItems: "end",
                    justifyContent: "right",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "10px",
                      backgroundColor: "#c4eafcff",
                      boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                      width: mobile ? "90vw" : "40vw",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "12px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: mobile ? "15px" : "18px",
                        fontWeight: "700",
                      }}
                    >
                      Price Details
                    </p>
                    <p
                      style={{
                        padding: "14px",
                        fontSize: "14px",
                        fontWeight: "500",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "0.3px solid gray",
                      }}
                    >
                      <span style={{ color: "gray" }}>Total</span>
                      {realBookingDetails.up && (
                        <>
                          {" "}
                          <span style={{ color: "gray" }}>
                            Up:{realBookingDetails.up.fare}/- X {totalSeats}
                          </span>
                          <span style={{ color: "gray" }}>
                            Down:{realBookingDetails.down.fare}/- X{" "}
                            {totalSeats}{" "}
                          </span>
                        </>
                      )}
                    </p>
                    <p
                      style={{
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: "500",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "gray" }}> Total :</span>
                      {realBookingDetails.up
                        ? Number(
                            realBookingDetails.up.fare +
                              realBookingDetails.down.fare,
                          )
                        : Number(bookingDetals.fare) * totalSeats}
                      /- Platform Fee:{" "}
                      {platformFeePercentage!==0?
                      
                      (((realBookingDetails.up
                        ? Number(
                            realBookingDetails.up.fare +
                              realBookingDetails.down.fare,
                          )
                        : Number(bookingDetals.fare)) *
                        totalSeats *
                        platformFeePercentage) /
                        100)
                        :platformFeeFixed
                        
                        }
                      /-
                    </p>
                    <p
                      style={{
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: "500",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "gray" }}> Cgst:</span>
                      {bookingDetals.selectedBus.fareDetails.cgstPercentage}%
                    </p>
                    <p
                      style={{
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: "500",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "gray" }}> Cgst:</span>
                      {bookingDetals.selectedBus.fareDetails.sgstPercentage}%
                    </p>

                    <p
                      style={{
                        padding: "16px",
                        fontSize: "14px",
                        fontWeight: "500",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "gray" }}> Total Amount</span>

                      <span>
                        {(selectedCoupon
                          ? realBookingDetails.up
                            ? totalCuoponCalculation(
                                Number(
                                  realBookingDetails.up.fare +
                                    realBookingDetails.down.fare,
                                ) * totalSeats,
                              )
                            : totalCuoponCalculation(
                                Number(bookingDetals.fare) * totalSeats,
                              )
                          : realBookingDetails.up
                            ? totalCalculation(
                                Number(
                                  realBookingDetails.up.fare +
                                    realBookingDetails.down.fare,
                                ) * totalSeats,
                              )
                            : totalCalculation(
                                Number(bookingDetals.fare) * totalSeats,
                              ).toFixed(2))
                              
                              }
                        /-
                      </span>
                    </p>

                    {!isActive ? (
                      <p
                        onClick={handleBusBook}
                        style={{
                          width: "200px",
                          borderRadius: "10px",
                          padding: "8px",
                          backgroundColor: "#3b8bb1ff",
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "700",
                          margin: "20px 40px",
                          textAlign: "center",
                        }}
                      >
                        {load ? <Loader2 /> : "Book Now"}
                      </p>
                    ) : (
                      <p
                        onClick={() => {
                          !waitingList
                            ? handlePayment(bookingId)
                            : handlePaymentWaiting(bookingId);
                        }}
                        style={{
                          width: "80%",
                          borderRadius: "10px",
                          padding: "8px",
                          backgroundColor: "rgb(145, 5, 29)",
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "700",
                        }}
                      >
                        {load ? <Loader2 /> : "Pay Now"}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <p
                style={{
                  padding: "6px",
                  borderRadius: "3px",
                  border: "0.3px solid grey",
                  cursor: "pointer",
                  fontWeight: "600",
                  width: "fit-content",
                  zIndex: 1000,
                  bottom: "20px",
                  left: "20px",
                }}
                onClick={() => navigate("/bus-details")}
              >
                {"< "}Back
              </p>
              <div
                style={{
                  borderRadius: "10px",
                  backgroundColor: "rgb(255, 255, 255)",
                  height: "25vh",
                  boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                  width: "90vw",
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                }}
              >
                <p style={{ fontSize: "15px", fontWeight: "700" }}>
                  Traveller’s Details ({totalSeats} people)
                </p>
                <div style={{ height: "24vh", overflowY: "auto" }}>
                  {Array.from({ length: totalSeats }).map((i, index) => (
                    <div>
                      <p style={{ fontSize: "14px", fontWeight: "300" }}>
                        <input type="checkbox" />
                        <span>Same as Profile Information</span>
                      </p>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          padding: "10px",
                          width: "100%",
                        }}
                      >
                        <select
                          value={gen[index]}
                          onChange={(e) =>
                            handleGenChange(index, e.target.value)
                          }
                          style={{ width: "70px" }}
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                        <input
                          style={{
                            borderRadius: "2px",
                            padding: "2px",
                            fontSize: "10px",
                            border: "0.2px solid gray",
                            outline: "none",
                          }}
                          placeholder="Full name"
                          value={name[index]}
                          onChange={(e) =>
                            handleNameChange(index, e.target.value)
                          }
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          padding: "10px",
                        }}
                      >
                        <input
                          style={{
                            borderRadius: "2px",
                            padding: "2px",
                            fontSize: "10px",
                            border: "0.2px solid gray",
                            outline: "none",
                            width: "70px",
                          }}
                          type="number"
                          placeholder="Age"
                          value={age[index]}
                          onChange={(e) =>
                            handleAgeChange(index, e.target.value)
                          }
                        />
                        <input
                          style={{
                            borderRadius: "2px",
                            padding: "3px",
                            fontSize: "10px",
                            border: "0.2px solid gray",
                            outline: "none",
                          }}
                          placeholder="Enter Phone Number"
                          type="number"
                          value={phNum[index]}
                          onChange={(e) =>
                            handlePhChange(index, e.target.value)
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div
                style={{
                  borderRadius: "10px",
                  backgroundColor: "#c4eafcff",
                  height: "fit-content",
                  boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                  width: "90vw",
                  display: "flex",
                  flexDirection: "column",
                  padding: "5px",
                }}
              >
                <p style={{ fontSize: "20px", fontWeight: "700" }}>
                  Available Coupon
                </p>
                <div
                  style={{
                    width: "96%",
                    overflowX: "auto",
                    overflowY: "hidden",
                    display: "flex",
                    gap: "5px",
                  }}
                >
                  {availableCoupon.map((item, ind) => (
                    <div
                      key={ind}
                      style={{
                        backgroundColor:
                          selectedCoupon?.code === item.code
                            ? "#abf5e8ff"
                            : "white",
                        height: "100%",
                        minWidth: "60%",
                        padding: "6px",
                        borderRadius: "12px",
                        marginBottom: "6px",
                        cursor: "pointer",
                        border: "0.3px solid grey",

                        filter: !isActive ? "blur(4px)" : "none",
                        pointerEvents: !isActive ? "none" : "auto",
                        userSelect: !isActive ? "none" : "auto",
                      }}
                      onClick={() => {
                        !isActive
                          ? toast.warning("⚠️ Please complete booking first")
                          : handleApplyCoupon(bookingId, item.code);
                      }}
                    >
                      <p style={{ fontSize: "20px", fontWeight: "700" }}>
                        {item.code}
                      </p>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontWeight: "700",
                          color: "#757373ff",
                        }}
                      >
                        <span>Offer Type : {item.type}</span>
                        <span>Coupon Type :{item.couponType}</span>
                      </p>
                      <p style={{ fontSize: "14px", fontWeight: "600" }}>
                        Limit :{item.limit}
                      </p>

                      <p style={{ fontWeight: "500", color: "#3b4499ff" }}>
                        Discount :{item.discountPercentage}%
                      </p>
                      <p style={{ color: "gray" }}>{item.description}</p>
                      <p style={{ fontSize: "12px", fontWeight: "700" }}>
                        Valid until :{formattedDate(item.validUntil)}
                      </p>
                    </div>
                  ))}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    gap: "20px",
                    alignItems: "end",
                    justifyContent: "right",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "10px",
                      backgroundColor: "#c4eafcff",
                      boxShadow: "0 4px 8px rgba(94, 36, 36, 0.2)",
                      width: mobile ? "90vw" : "40vw",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "12px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: mobile ? "18px" : "24px",
                        fontWeight: "700",
                      }}
                    >
                      Price Details
                    </p>
                    <p
                      style={{
                        padding: "16px",
                        fontSize: "16px",
                        fontWeight: "500",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "0.3px solid gray",
                      }}
                    >
                      <span style={{ color: "gray" }}>Total</span>
                      <span style={{ color: "gray" }}>
                        {bookingDetals.fare} X{totalSeats}
                      </span>
                      <span>{bookingDetals.fare * totalSeats} /-</span>
                    </p>
                    <p
                      style={{
                        padding: "10px",
                        fontSize: "16px",
                        fontWeight: "500",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "gray" }}> Total Amount</span>
                      <span>
                        {selectedCoupon
                          ? Number(bookingDetals.fare) * totalSeats -
                            (Number(selectedCoupon.discountPercentage) *
                              (bookingDetals.selectedBus.fareDetails.basePrice *
                                totalSeats)) /
                              100
                          : Number(bookingDetals.fare) * totalSeats}
                        /-
                      </span>
                    </p>
                    {isActive ? (
                      <p
                        onClick={() => {
                          !waitingList
                            ? handlePayment(bookingId)
                            : handlePaymentWaiting(bookingId);
                        }}
                        style={{
                          width: "80%",
                          borderRadius: "10px",
                          padding: "8px",
                          backgroundColor: "rgb(145, 5, 29)",
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "700",
                        }}
                      >
                        {load ? <Loader2 /> : "Pay Now"}
                      </p>
                    ) : (
                      <p
                        onClick={handleBusBook}
                        style={{
                          width: "80%",
                          borderRadius: "10px",
                          padding: "8px",
                          backgroundColor: "#3b8bb1ff",
                          color: "white",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "700",
                        }}
                      >
                        {load ? <Loader2 /> : "Book Now"}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          
        </div>
      </div>

      {payModal && (
        <div
          style={{
            padding: "10px",
            borderRadius: "10px",
            backgroundColor: "#c9c9c9ff",
            position: "absolute",
            top: "250px",
            left: mobile ? "12px" : "30vw",
            zIndex: 9999,
            width: "90vw",
            height: "40vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            backgroundImage: `url('/Sliding/booking-bus.png')`, // or a full URL
            backgroundSize: "cover", // make image cover the div
            backgroundPosition: "center", // center the image
            backgroundRepeat: "no-repeat", // prevent tiling
          }}
        >
          <p style={{ fontSize: "20px", fontWeight: 700, textAlign: "center" }}>
            Your Seats are Booked
          </p>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p
              onClick={() => navigate("/ticket/" + bookingId)}
              style={{
                padding: "5px",
                borderRadius: "7px",
                cursor: "pointer",
                backgroundColor: "#ff7b2fff",
                color: "white",
              }}
            >
              View Ticket
            </p>
            <p
              onClick={() => handlePayment(bookingId)}
              style={{
                padding: "5px",
                borderRadius: "7px",
                cursor: "pointer",
                backgroundColor: "#23b6aaff",
                color: "white",
              }}
            >
              Pay Now
            </p>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Payment;
